module.exports = __webpack_public_path__ + "img/05-Pic-02.e25b11cc.png";